import styled from 'styled-components';

export const LogoIcon = styled.img`
    width: 40px;
    margin-right: 7px;
`;

export const LogoText = styled.img`
    width: 130px;
`;